import { colors, fonts } from '@grupoboticario/flora-tokens/drJones/web/ds'

export const drJones = {
  colors,
  fonts,
}
